export type MergeInput<T> = Array<Partial<T> | undefined>;
/**
 * Merge generic type arguments into a union type of all arguments
 *
 * @example
 * type Result = Merged<[ { foo: string }, { bar: number } ]>;
 * type Result = { foo: string, bar: number };
 */
export type Merged<T> = T extends [infer E, ...infer REST]
    ? E extends undefined
        ? Merged<REST>
        : E & Merged<REST>
    : unknown;

/**
 * Validate that a `Merged<>` type extends and expected type, otherwise returns "never"
 */
export type ValidMergeInput<T, INPUTS extends MergeInput<T>> =
    Merged<INPUTS> extends T ? INPUTS : never;

/**
 * Extract required keys from a type T
 */
export type RequiredKeys<T> = {
    [K in keyof T]-?: object extends Pick<T, K> ? never : K;
}[keyof T];

export function mergeInputs<T>(...inputs: Array<Partial<T> | undefined>): T {
    const filteredInputs = inputs.filter(
        (input): input is Partial<T> => input !== undefined,
    );
    return Object.assign({}, ...filteredInputs) as T;
}
